import { z } from 'zod'

// Spring Data 의 Page 응답 봉투. Slice 에 전체 개수가 더해진다. 앱이 읽는 것은 content 와 쪽수뿐이라
// pageable·sort 는 받지 않는다.
export const pageSchema = <Item extends z.ZodType>(item: Item) =>
  z.object({
    content: z.array(item),
    totalPages: z.number(),
    totalElements: z.number(),
    first: z.boolean(),
    last: z.boolean(),
    size: z.number(),
    number: z.number(),
    numberOfElements: z.number(),
    empty: z.boolean(),
  })

export type Page<Item> = {
  content: Item[]
  totalPages: number
  totalElements: number
  first: boolean
  last: boolean
  size: number
  number: number
  numberOfElements: number
  empty: boolean
}
